// Keeps the year rail (position: fixed) contained within its own section. A
// fixed element is pinned to the viewport and would otherwise overlap the next
// section once the editorial section scrolls past. We hide the rail as soon as
// the section bottom rises above the rail bottom, and show it again while the
// section still covers the rail.
//
// Everything is read fresh in viewport coordinates on each frame: the fixed
// rail's bottom is constant, the section's bottom moves on scroll. No cached
// measurement, so there is no init/resize race to get wrong.

const HIDDEN_CLASS = 'is-hidden'

class EditorialRail {
  constructor (section) {
    this.section = section
    this.rail = section.querySelector('.redesign-editorial-blog__years')

    this.ticking = false
    this.hidden = false

    this.onScroll = this.onScroll.bind(this)
  }

  init () {
    if (!this.rail) return

    // Capture phase so this fires whether the document scrolls (desktop) or an
    // inner container scrolls (mobile uses body as the scroller — scroll does
    // not bubble, but capture still catches it on the way down).
    document.addEventListener('scroll', this.onScroll, {
      passive: true,
      capture: true
    })
    window.addEventListener('resize', this.onScroll, { passive: true })

    this.update()
  }

  onScroll () {
    if (this.ticking) return
    this.ticking = true
    window.requestAnimationFrame(() => {
      this.update()
      this.ticking = false
    })
  }

  update () {
    const railBottom = this.rail.getBoundingClientRect().bottom
    const sectionBottom = this.section.getBoundingClientRect().bottom

    this.setHidden(sectionBottom < railBottom)
  }

  setHidden (hidden) {
    if (hidden === this.hidden) return
    this.hidden = hidden
    this.rail.classList.toggle(HIDDEN_CLASS, hidden)
  }
}

export default (section) => {
  new EditorialRail(section).init()
}
